import SessionTimeoutAlert from './SessionTimeoutAlert';

export default function SessionTimeoutAlertWrapper() {
  return <SessionTimeoutAlert />;
}
